import React from 'react';

import { Box, TextField } from '@mui/material';
import { debounce } from 'lodash';

import searchData from '../../data/search-data';
import SearchItem from './search-item';

interface SearchNodeItem {
  type: string;
  title: string;
  node: string;
}

interface SearchNodeProps {
  bgColor: string;
  nodeType?: string;
}

const SearchNode: React.FC<SearchNodeProps> = ({ bgColor }) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredData, setFilteredData] = React.useState(searchData);

  const debouncedSearch = React.useMemo(
    () =>
      debounce((searchValue: string) => {
        const filtered = searchData.filter((item: SearchNodeItem) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilteredData(filtered);
      }, 500),
    []
  );

  const handleSearch = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setSearchTerm(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <Box sx={{ width: '100%' }}>
      <TextField
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={handleSearch}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
      <ul className="node-list">
        {filteredData.map((item: SearchNodeItem) => (
          <SearchItem
            key={item.type}
            node={item.node}
            title={item.title}
            type={item.type}
            bgColor={bgColor}
          />
        ))}
      </ul>
    </Box>
  );
};

export default SearchNode;
